import DashboardData from "../../components/admin/dashboard/DashboardData";

const DashboardPage = () => {
  return (
    <>
      <DashboardData />
    </>
  );
};

export default DashboardPage;
